<nb-layout>
  <nb-layout-header fixed *ngIf="isLoggedIn">
    <app-header></app-header>
  </nb-layout-header>

  <nb-sidebar *ngIf="isLoggedIn">
    <app-pages></app-pages>
    <nb-sidebar-footer [style.background-color]="environment.color">
      <strong>{{ compacted ? environment.fullName[0] : environment.fullName }}</strong>
    </nb-sidebar-footer>
  </nb-sidebar>

  <nb-layout-column>
    <router-outlet></router-outlet>
  </nb-layout-column>
</nb-layout>
